import { render, staticRenderFns } from "./JsonAdder.vue?vue&type=template&id=32b2917c&scoped=true&"
import script from "./JsonAdder.vue?vue&type=script&lang=js&"
export * from "./JsonAdder.vue?vue&type=script&lang=js&"
import style0 from "./JsonAdder.vue?vue&type=style&index=0&id=32b2917c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2917c",
  null
  
)

export default component.exports